export default __webpack_public_path__ + "static/media/NoRec.52cdd55c.svg";